import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ClubDiscountCounter } from '../interfaces/club-discount-counter';
import { ClubDiscount } from '../interfaces/club-discount';

import { ClubAdmin } from '../interfaces';
import { HttpService } from './http.service';

import * as lodash from 'lodash';
import { map } from '../store';
import { ClubUserPaymentPlan } from '../models/club/club-user-payment-plan';

@Injectable()
export class ClubMemberService {

  private _url = '/api/ClubMember';

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getDiscountCount(clubProgramID: string) {
    return this.http.get<ClubDiscountCounter>(this._url + '/getDiscountCounts/' + clubProgramID);
  }

  getDiscounts(clubProgramID: string): Observable<ClubDiscount[]> {
    return this.http.get<ClubDiscount[]>(this._url + '/getDiscountList/' + clubProgramID);
  }

  getUserProgramPaymentDetailsFlyout(userID: string, clubProgramID: string): Observable<any[]> {
    return this.http.get<any>(this._url + '/getUserProgramPaymentDetailsFlyout/' + userID + '/' + clubProgramID);
  }

  getClubPaymentUserFeePlan(userID: string, clubProgramID: string): Observable<any[]> {
    return this.http.get<ClubUserPaymentPlan[]>(this._url + '/getClubPaymentUserFeePlan/' + userID + '/' + clubProgramID);
  }

  getUserProgramDetailsFlyoutTransactionList(userId: string, clubProgramID: string): Observable<any[]> {
    return this.http.get<any[]>(this._url + '/getUserProgramDetailsFlyoutTransactionList/' + userId + '/' + clubProgramID)
      .pipe(map(res => {
        const data = lodash.sortBy(res, 'transactionID');
        let paymentNumber = 0;
        data.forEach((history, index) => {
          history.paymentNumber = paymentNumber;
          if (index > 0 && data[index - 1].transactionID === history.transactionID) {
            history.paymentNumber = paymentNumber;
          } else {
            paymentNumber++;
            history.paymentNumber = paymentNumber;
          }
          history.transactionDate = history.transactionDate.slice(0, 10);
        });
        return lodash.sortBy(data, 'transactionDate');
      }));
  }

  getMedicalQuestions(clubProgramID: number, userID: number) {
    return this.http.get<any>(this._url + '/medical-questions/' + clubProgramID + '/' + userID);
  }

  getListOfAllQuestionsAndAnswers(userId: string, clubProgramID: string): Observable<any[]> {
    return this.http.get<any[]>(this._url + '/getListOfAllQuestionsAndAnswers/' + userId + '/' + clubProgramID);
  }

  getListOfQuestionsAndAnswers(userId: string, clubProgramID: string): Observable<any[]> {
    return this.http.get<any[]>(this._url + '/getListOfQuestionsAndAnswers/' + userId + '/' + clubProgramID);
  }

  getProgramAdmins(clubprogramID: number): Observable<ClubAdmin[]> {
    return this.httpService.get(`${this._url}/getClubProgramAdmins/${clubprogramID}`);
  }

  getUser(userId: number): Observable<any> {
    return this.httpService.get(`${this._url}/getUser/${userId}`);
  }

  getStaffByEmail(email: string) {
    return this.httpService.get(`${this._url}/getStaffByEmail/${email}`);
  }

  updateUser(user) {
    return this.httpService.post(`${this._url}/update-user-info`, user);
  }

  addClubTeamUser(teamID: number, data: any) {
    return this.httpService.post(`${this._url}/add-club-team-user/${teamID}`, data);
  }

  validateNewClubUserID(clubID: number, teamID: number, userID: number) {
    return this.httpService.get(`${this._url}/validate-new-club-player-id/${clubID}/${teamID}/${userID}`);
  }

  validateNewClubUserEmail(clubID: number, teamID: number, email: string) {
    return this.httpService.get(`${this._url}/validate-new-club-player-email/${clubID}/${teamID}`, { params: { email } });
  }

  validateNewClubUserData(clubID: number, teamID: number, data: any) {
    return this.httpService.post(`${this._url}/validate-new-club-player-data/${clubID}/${teamID}`, data);
  }

  removeAllPayments(data) {
    return this.httpService.post(`/api/ClubUserProgramFee/remove-payments`, data);
  }

  revertAllPayments(clubUserProgramFeeID) {
    return this.httpService.get(`/api/ClubUserProgramFee/revert-payments/` + clubUserProgramFeeID);
  }

  updateUserEmail(UserID: number, Email: string) {

    var payload = {
      UserID: UserID,
      Email: Email
    };

    return this.httpService.post(`${this._url}/update-user-Email`, payload);
  }

  getFamilyInfo(userId: number) {
    return this.httpService.get(`/api/Player/get-family-info/${userId}`);
  }

  getClubUserProgramFeeNoteByClubUserProgramFeeNoteID(clubuserprogramfeeID: number) {
    return this.httpService.get(this._url + '/get-club-user-program-fee-note-by-clubuserprogramfeeID/' + clubuserprogramfeeID);
  }

  addOrUpdateClubUserProgramFeeNote(payload: any) {
    return this.httpService.post(this._url + '/add-or-update-club-user-program-fee-note', payload);
  }
  deleteClubUserProgramFeeNoteByClubUserProgramFeeNoteID(clubUserProgramFeeNoteID: number) {
    return this.httpService.delete(`${this._url}/delete-club-user-program-fee-note/${clubUserProgramFeeNoteID}`);
  }
    
}



// WEBPACK FOOTER //
// ./src/app/services/club-member.service.ts